// React
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

// MUI
import { Grid } from "@mui/material";

// Custom components
import AppPage from "@/ui/AppPage/AppPage";
import { Permissions } from "@/lib/permissions";

import QualityControlToolbar from "./QualityControlToolbar";
import QualityControlMap from "./QualityControlMap";
import QualityControlKatoviTable from "./QualityControlKatoviTable";
import QualityControlDijeloviTable from "./QualityControlDijeloviTable";
import QualityControlInfo from "./QualityControlInfo";
import QualityControlImageCrop from "./QualityControlImageCrop";

// Context
import SnackbarContext from "@/ui/SnackbarContext/SnackbarContext";
import { SnackbarContextType } from "@/@types/ui/SnackbarContext";
import OperationsContext, {
  OperationsContextType,
} from "@/components/OperationsContext/OperationsContext";
import DialogContext from "@/ui/DialogContext/DialogContext";
import { DialogContextType } from "@/@types/ui/DialogContext";

// DC
import { DCRecord } from "@/@types/lib/dataController";
import dataController from "@/lib/dataController";
import modelObjekti from "@/models/objekti";
import modelQCFunction from "@/models/qc_function";
import LoaderContext from "@/components/LoaderContext/LoaderContext";

// Constants
const MAP_ID = 83; // QC Map

const QualityControlPage = () => {
  // Contexts
  const snackbarContext = useContext(SnackbarContext) as SnackbarContextType;
  const operationsContext = useContext(
    OperationsContext
  ) as OperationsContextType;
  // const dialogContext = useContext<DialogContextType>(DialogContext);
  const loaderContext = useContext(LoaderContext);

  // Refs
  const dontRefresh = useRef<boolean>(false);
  const katRecord = useRef<DCRecord | null>(null);
  // const locationUsed4Obj = useRef<boolean>(false);

  // States
  const [records, setRecords] = useState<Array<DCRecord>>([]); // objekti
  const [selectedRecord, setSelectedRecord] = useState<DCRecord | null>(null);
  const [selectedKat, setSelectedKat] = useState<DCRecord | null>(null);
  const [imagesBasicInfo, setImagesBasicInfo] = useState<Array<DCRecord>>([]); // i think this are the arrows for all images of obj, we probably dont need this

  const [qcFunctions, setQcFunctions] = useState<DCRecord[]>([]);
  const [selectedQcFunction, setSelectedQcFunction] = useState<DCRecord | null>(
    null
  );

  const [qcObjectRecords, setQcObjectRecords] = useState<DCRecord[]>([]);

  // DataControllers
  const baseRecordPath = "operations/objekti/";
  const dc = new dataController(modelObjekti, baseRecordPath);

  const dcQcFunctions = new dataController(modelQCFunction);

  // Data fetch calls
  const refreshRecords = () => {
    const { selectedProject } = operationsContext;
    if (selectedProject) {
      loaderContext.toggleLoading(true);
      const url = `operations/projekti/${selectedProject.id}/objekti/`;
      dc.GetData(url)
        .then((resp) => {
          if (resp.success && Array.isArray(resp.data)) {
            setRecords(resp.data);

            if (selectedRecord && selectedRecord.id) {
              const newValueForSelectedRecord = resp.data.find(
                (x) => x.id === selectedRecord.id
              );
              if (newValueForSelectedRecord) {
                setSelectedRecord(newValueForSelectedRecord);
              } else {
                setSelectedRecord(null);
              }
            }

            if (resp.data.length === 0) {
              snackbarContext.showNotification(
                "messages.nodata",
                "warning",
                true
              );
            }
          }
        })
        .catch((resp) => {
          console.log(resp);
        })
        .finally(() => {
          loaderContext.toggleLoading(false);
        });
    } else {
      setRecords([]);
    }
  };

  const refreshQcFunctions = () => {
    dcQcFunctions.GetData().then((resp) => {
      if (resp.success && Array.isArray(resp.data)) {
        setQcFunctions(resp.data);
      }
    });
  };

  const refreshQcObjectRecords = (qcFunctionId: number, projectId: number) => {
    loaderContext.toggleLoading(true);
    dc.GetData(
      `qc/functions/${qcFunctionId}/results/?projekt_id=${projectId}`
    ).then((resp) => {
      if (resp.success && resp.data && Array.isArray(resp.data)) {
        setQcObjectRecords(resp.data);
      } else {
        setQcObjectRecords([]);
      }
    }).finally(() => {
      loaderContext.toggleLoading(false);
    })
  };

  const refreshSelectedObjectRecord = (objectId: number) => {
    dc.GetDataSingle(objectId)
      .then((resp: any) => {
        if (resp.success && resp.data) {
          /*let imagesState: DCRecord[] = [];
          if ("images" in (resp.data as DCRecord)) {
            const { images } = resp.data as DCRecord;
            if (images && Array.isArray(images)) {
              imagesState = (images as DCRecord[]).map(
                (img: DCRecord, i: number) =>
                  ({
                    ...img,
                    id: img.image_id as number,
                    objektId: (resp.data as DCRecord).id,
                    imageId: img.image_id,
                    ordinal: i + 1,
                    wkt: img.yaw_wkt,
                    type: "image-basic-info",
                  } as DCRecord)
              );
              setImagesBasicInfo(imagesState);
            }
          }*/
          setSelectedRecord(resp.data);
        }
      })
      .catch()
      .finally(() => {});
  };

  // Handlers

  const handleRecordSelect = (id: number, record: DCRecord | null) => {
    if (selectedRecord !== null && id === selectedRecord.id) {
      setSelectedRecord(null);
      return;
    } else if (id !== -1 && id !== null) {
      const newRecord = records.find((element) => element.id === id);
      if (newRecord) {
        setSelectedRecord(newRecord);
      } else {
        setSelectedRecord(null);
      }
    } else {
      setSelectedRecord(null);
    }

    refreshSelectedObjectRecord(id);
  };

  const handleQcRecordselect = (id: number, record: DCRecord | null) => {
    if (selectedQcFunction !== null && id === selectedQcFunction.id) {
      setSelectedQcFunction(null);
      return;
    } else if (id !== -1 && id !== null) {
      const newRecord = qcFunctions.find((element) => element.id === id);
      if (newRecord) {
        setSelectedQcFunction(newRecord);
      } else {
        setSelectedQcFunction(null);
      }
    } else {
      setSelectedQcFunction(null);
    }

    /*dc.GetDataSingle(id)
      .then((resp: any) => {
        if (resp.success && resp.data) {
          setSelectedRecord(resp.data);
        }
      })
      .catch()
      .finally(() => {});*/ // TODO_: IMPLEMENT NIGA
  };

  const handleQcStateChange = () => {
    refreshRecords();
    if (selectedRecord) {
      refreshSelectedObjectRecord(selectedRecord.id as number);
    }
  };

  const handleKatSelect = (id: number, record: DCRecord | null) => {
    setSelectedKat(record);
  };

  const handleClearSelections = () => {
    setSelectedRecord((prev) => (prev === null ? prev : null));
  };

  // UseEffects

  useEffect(() => {
    refreshQcFunctions();
  }, []);

  useEffect(() => {
    if (!selectedQcFunction || !operationsContext.selectedProject) {
      setQcObjectRecords([]);
      return;
    }

    refreshQcObjectRecords(
      selectedQcFunction.id as number,
      operationsContext.selectedProject.id as number
    );
  }, [selectedQcFunction, operationsContext.selectedProject]);

  useEffect(() => {
    if (
      operationsContext.selectedProject === null &&
      selectedRecord !== null &&
      operationsContext.projectItems.length !== 0
    ) {
      const { projekt_id } = selectedRecord;
      if (projekt_id) {
        operationsContext.selectProject(projekt_id as number);
      }
    }
  }, [selectedRecord, operationsContext.projectItems]);

  /*useEffect(() => {
    if (
      operationsContext.selectedFishnet === null &&
      selectedRecord !== null &&
      operationsContext.fishnetItems.length !== 0
    ) {
      const { fishnet_id } = selectedRecord;
      if (fishnet_id) {
        dontRefresh.current = true;
        operationsContext.selectFishnet(fishnet_id as number);
      }
    }
  }, [selectedRecord, operationsContext.fishnetItems]);*/

  useEffect(() => {
    if (operationsContext.selectedProject) {
      refreshRecords();
      handleClearSelections();
    } else {
      setRecords([]);
      handleClearSelections();
    }
  }, [operationsContext.selectedProject]);

  // Memoized

  const isQcChecked = useMemo(
    () =>
      selectedRecord !== null ? (selectedRecord.qc_check as boolean) : false,
    [selectedRecord]
  );

  // Render
  return (
    <AppPage needPermission={[Permissions.Administration]}>
      <Grid container height={"calc( 100% - 48px )"} spacing={1}>
        <Grid item xs={12}>
          <QualityControlToolbar
            records={records}
            selectedRecord={selectedRecord}
            onRecordSelect={handleRecordSelect}
            onRecordChange={handleQcStateChange}
            qcRecords={qcFunctions}
            selectedQcRecord={selectedQcFunction}
            onQcRecordSelect={handleQcRecordselect}
            isQcChecked={isQcChecked}
            qcObjectFilter={qcObjectRecords}
            selectedQcFunction={selectedQcFunction}
          />
        </Grid>
        <Grid item xs={12} md={6} height={"100%"}>
          <QualityControlMap
            records={records}
            selectedObjekt={selectedRecord}
            lokacije={[]}
            onLokacijeSelect={() => {}}
            selectedImageId={null}
            onObjektSelect={handleRecordSelect}
            imagesBasicInfo={imagesBasicInfo}
            mapId={MAP_ID}
            selectedLokacija={null}
            refreshLocations={() => {}}
            selectedObjektFor3D={selectedRecord}
            qcRecords={qcObjectRecords}
          />
        </Grid>
        <Grid item container xs={12} md={6} height={"100%"}>
          <Grid item xs={12} height={"35%"}>
            <QualityControlKatoviTable
              isQcChecked={isQcChecked}
              baseRecordPath={baseRecordPath}
              baseRecordId={
                selectedRecord ? (selectedRecord.id as number) : null
              }
              selectedKat={selectedKat}
              onRowSelect={handleKatSelect}
            />
          </Grid>
          <Grid item xs={12} height={"35%"}>
            <QualityControlDijeloviTable
              isQcChecked={isQcChecked}
              baseRecordPath={baseRecordPath}
              baseRecordId={
                selectedRecord ? (selectedRecord.id as number) : null
              }
              selectedKat={selectedKat}
              onRowSelect={() => {}}
            />
          </Grid>
          <Grid item container xs={12} height={"30%"}>
            <Grid item xs={12} md={6} height={"100%"}>
              <QualityControlInfo
                dc={dc}
                recordId={
                  selectedRecord ? (selectedRecord.id as number) : undefined
                }
                isQcChecked={isQcChecked}
                qcFunctions={qcFunctions}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <QualityControlImageCrop
                ordinal={1}
                selectedRecord={selectedRecord}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <QualityControlImageCrop
                ordinal={2}
                selectedRecord={selectedRecord}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AppPage>
  );
};

export default QualityControlPage;
